<template>
    <div class='sub-content'> <!-- 여기까지 page header 이하 수정해서 사용-->
      <div class="car-option-wrap float-left">
        <dx-tree-list ref='refBomSubGrid'
          :data-source='bomInfoList'
          :height='gridHeight'
          :autoExpandAll='true'
          :show-borders="true" :showRowLines = 'true'
          :column-auto-width="true"
          :hover-state-enabled = "true"
          key-expr="selfKey"
          parent-id-expr="상위품번"
          :selection="{ mode: 'single' }"
          :focused-row-enabled="true"
          :allow-column-resizing="true"
          column-resizing-mode="nextColumn"
          :auto-navigate-to-focused-row="false"
          @toolbar-preparing='onToolbarPreparingSub'
        >
          <DxSearchPanel
            :visible="false"
            placeholder="검색..."
          />
          <DxFilterRow
            :visible="true"
            apply-filter="auto"
          />
          <DxColumn
            caption="차종/사양"
            data-field="품번"
            :visible='true'
            sort-order="asc"
            width="150"
          >
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="차종명/사양명"
            data-field="품명"
            width="150"
          >
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="점유율"
            data-field="생산점유율"
            format='#0.##%'
            dataType="number"
            width="120"
          >
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="비고"
            data-field="비고"
          >
          </DxColumn>
          <dx-paging :enabled="false"/>
          <dx-scrolling mode="standard" showScrollbar='always' :useNative='false'/>
          <dx-sorting mode="none"/>
          <template #bom-sub>
            <div class="toolbar-label" style='font-size:1.2rem;margin-left:0px;'>
              <b v-if='selectedRow'>BOM(차종: {{selectedRow.모델코드}})</b>
            </div>
        </template>
        </dx-tree-list>
      </div>
      <div class="upload-result-wrap float-left">
        <dx-data-grid ref='refReadProductionInfoResult'
          :data-source='readProductionInfoResult'
          :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
          :hover-state-enabled = "true" :allowColumnResizing = 'true'
          column-resizing-mode = 'widget' :allow-column-reordering = "true"
          :height='gridHeight' :row-alternation-enabled="true"
          :focused-row-enabled="true"
          :auto-navigate-to-focused-row="false"
          key-expr="seqId"
          @toolbar-preparing='onToolbarPreparingProduct'
        >
          <DxSearchPanel
            :visible="true"
            placeholder="검색..."
          />
          <DxExport
            :enabled="true"
            file-name="사양맵핑에러"
          />
          <DxFilterRow
            :visible="true"
            apply-filter="auto"
          />
          <DxColumn
            :allowEditing='false'
            caption="고객사"
            data-field="발주사"
            sort-order="asc"
          >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="차종"
            data-field="차종"
            sort-order="asc"
          >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="사양"
            data-field="사양"
            sort-order="asc"
          >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="고객사품번"
            data-field="납입품번"
            :visible='true'
          >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="품번"
            data-field="품번"
            :visible='true'
          >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="자재유형"
            data-field="자재유형"
          >
            <DxLookup
              :data-source="meterialTypeLookup"
              display-expr="코드명"
              value-expr="코드"
            />
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="품명/Error"
            data-field="품명"
            sort-order="asc"
            width="200"
          >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="원단위"
            data-field="원단위"
          >
          </DxColumn>

          <DxSummary>
            <DxTotalItem
              value-format='#,##0'
              show-in-column="고객사"
              display-format="{0} (건)"
            />
          </DxSummary>
          <dx-paging :enabled="false"/>
          <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
          <dx-sorting mode="multiple"/>
        </dx-data-grid>
      </div>
      <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
      <input id="batch-detail-input" type="file" @change="onDetailFileChange($event)" accept=".xlsx" style='display: none;'>
    </div> <!--sub-conten end-->
</template>

<script>
import Loading from 'vue-loading-overlay'
import ConstDef from '../../share/ConstDef'
import AppLib from '../../share/AppLib'
import { DxTreeList } from 'devextreme-vue/tree-list'
import DxDataGrid, { DxScrolling, DxFilterRow, DxExport, DxTotalItem, DxLookup,
  DxSummary, DxColumn, DxPaging, DxSorting, DxSearchPanel } from 'devextreme-vue/data-grid'
import ExcelJS from 'exceljs'
import { saveAs } from 'file-saver-es'
import axios from 'axios'

export default {
  name: 'login',
  data: function () {
    return {
      isLoading: false,
      userInfo: null,
      gridHeight: null,
      thisYear: null,
      thisMonth: null,
      yearArray: [],
      monthArray: [],
      bomInfoList: null,
      carProductionOpenBtn: null,
      carProductionSaveBtn: null,
      carFileReadError: false,
      customerLookup: null,
      meterialTypeLookup: null,
      // read result
      readProductionInfoResult: null,
      errorArray: [],
      optionProductArray: [],
      finishiedProduct: null
    }
  },
  components: {
    Loading,
    DxTreeList,
    DxSearchPanel,
    DxColumn,
    DxScrolling,
    DxFilterRow,
    DxPaging,
    DxSorting,
    DxExport,
    DxLookup,
    DxTotalItem,
    DxSummary,
    DxDataGrid
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
      return
    }
    this.thisYear = AppLib.getThisYear()
    for (let i = this.thisYear; i >= 2021; i--) {
      this.yearArray.push({ 'year': i })
    }
    this.thisMonth = AppLib.getThisMonth()
    for (let i = 1; i <= 12; i++) {
      if (i > 0 && i < 10) {
        this.monthArray.push({ 'name': i + '월', value: '0' + i })
      } else {
        this.monthArray.push({ 'name': i + '월', value: '' + i })
      }
    }
    this.customerLookup = this.$store.getters.getFirstVendor
    this.meterialTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.자재유형)
    this.refreshCarOptionList()
    this.refreshReadProductionInfoResult()
  },
  mounted () {
    this.gridHeight = (screen.height - 250) * 0.95
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    async exportExcel () {
      const workbook = new ExcelJS.Workbook()
      workbook.creator = this.userInfo.userName
      await this.exportCarOption(workbook)
      await this.exportSalesResult(workbook)
      // 다운로드
      const mimeType = { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
      const buffer = await workbook.xlsx.writeBuffer()
      const blob = new Blob([buffer], mimeType)
      saveAs(blob, `차종사양(${this.thisYear}-${this.thisMonth}-01).xlsx`)
    },
    async exportCarOption (workbook) {
      this.$refs.refBomSubGrid.instance.pageSize = 200
      const data = this.$refs.refBomSubGrid.instance.getDataSource()
      // console.log(data)
      let array = []
      data._items.forEach(item => {
        if (item.children.length > 0) {
          item.children.forEach(node => {
            let param = {
              차종: item.data.품번,
              사양: node.data.품번,
              점유율: node.data.생산점유율
            }
            array.push(param)
          })
        }
      })

      const worksheet = workbook.addWorksheet('차종사양')

      worksheet.getColumn(2).numFmt = '0%'

      worksheet.columns = [
        { header: '차종', key: '차종', width: 20 },
        { header: '사양', key: '사양', width: 20 },
        { header: '점유율', key: '점유율', width: 11 }
      ]
      // array.forEach(row => {
      //   worksheet.addRow({ 자종: row.차종, 사양: row.사양, 점유율: row.점유율 })
      // })
      let topBorder = {
        top: { style: 'thin' }
      }
      worksheet.addRows(array)
      for (let i = 0; i < array.length + 1; i++) {
        worksheet.getRow(i + 1).height = 17
        worksheet.getCell(`C${i + 2}`).numFmt = '0%'
        if (i === 0) {
          worksheet.getCell(`A${i + 1}`).border = {
            bottom: { style: 'medium' },
            right: { style: 'medium' },
            top: { style: 'medium' },
            left: { style: 'medium' }
          }
          worksheet.getCell(`A${i + 1}`).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'a6daff' }
          }
          worksheet.getCell(`B${i + 1}`).border = {
            bottom: { style: 'medium' },
            top: { style: 'medium' },
            right: { style: 'medium' }
          }
          worksheet.getCell(`B${i + 1}`).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'a6daff' }
          }
          worksheet.getCell(`C${i + 1}`).border = {
            bottom: { style: 'medium' },
            top: { style: 'medium' },
            right: { style: 'medium' }
          }
          worksheet.getCell(`C${i + 1}`).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'a6daff' }
          }
        }
      }
      let beforeCar = array[0].차종
      let startRow = 2
      for (let i = 2; i < array.length + 2; i++) {
        worksheet.getCell(`A${i}`).alignment = { vertical: 'middle', horizontal: 'left' }
        if (beforeCar !== array[i - 2].차종) {
          worksheet.mergeCells(`A${startRow}:A${i - 1}`)
          worksheet.getCell(`A${i}`).border = topBorder
          worksheet.getCell(`B${i}`).border = topBorder
          worksheet.getCell(`C${i}`).border = topBorder
          startRow = i
          beforeCar = array[i - 2].차종
        }
      }
      // last cell merge
      worksheet.mergeCells(`A${startRow}:A${array.length + 1}`)
      worksheet.getCell(`A${array.length + 2}`).border = topBorder
      worksheet.getCell(`B${array.length + 2}`).border = topBorder
      worksheet.getCell(`C${array.length + 2}`).border = topBorder

      // worksheet.insertRow(1, ['생산차종별 사양'])
      // worksheet.getRow(1).font = { size: 16, bold: true }
      // worksheet.insertRow(2)
    },
    insertSubTotal (list) {
      if (list.length === 0) return list
      let totalRecord = this.$Q.extend(true, {}, list[list.length - 1])
      // console.log(totalRecord)
      totalRecord.차종 = 'TOTAL'
      let beforeRow = list[0]
      const array = []
      list.forEach(item => {
        if (beforeRow.차종 !== item.차종 && item.차종.indexOf('GRAND') < 0) {
          array.push(totalRecord)
        }
        array.push(item)
        beforeRow = item
      })
      return array
    },
    async exportSalesResult (workbook) {
      const day = `${this.thisYear}-${this.thisMonth}-01`
      let companyList = null
      let salesInoutInfoDetail = null
      await this.$_sp.runNoEncodeFindProc('spFindAllSalesVendorList', { 기준일: day })
        .then((data) => {
          companyList = this.$_sp.MakeModel(data)
          // console.log(companyList)
        })

      for (let i = 0; i < companyList.length; i++) {
        await this.$_sp.runNoEncodeFindProc('spFindAllBom차종ByDateAndCompanyCode', { 기준일: day, 거래처코드: companyList[i].고객사코드 })
          .then((data) => {
            salesInoutInfoDetail = this.$_sp.MakeModel(data)
            salesInoutInfoDetail = this.insertSubTotal(salesInoutInfoDetail)
            // console.log(salesInoutInfoDetail)
          })
        const worksheet = workbook.addWorksheet(companyList[i].거래처명)
        const head = [
          { header: '차종', key: '차종' },
          { header: '고객사품번', key: '고객사품번', width: 18 },
          { header: '품번', key: '품번', width: 18 },
          { header: '품명', key: '품명', width: 38 },
          { header: '원수', key: '원수' },
          { header: '단가', key: '단가' },
          { header: '이월재고', key: '이월재고', width: 13 },
          { header: '계획수량', key: '계획수량', width: 13 },
          { header: '실적수량', key: '실적수량', width: 13 },
          { header: '납입수량', key: '납입수량', width: 13 },
          { header: '수량달성율', key: '수량달성율', width: 13 },
          { header: '예상매출액', key: '예상매출액', width: 13 },
          { header: '실적매출액', key: '실적매출액', width: 13 },
          { header: '납입매출액', key: '납입매출액', width: 13 },
          { header: '차액', key: '차액', width: 13 },
          { header: '금액', key: '금액' },
          { header: '달성율', key: '부가달성율' },
          { header: '사양', key: '사양', width: 13 },
          { header: '비고', key: '비고', width: 50 }
        ]
        worksheet.columns = head
        worksheet.addRows(salesInoutInfoDetail)
        worksheet.insertRow(1, [`${companyList[i].거래처명} 차종-사양별 품목현황`])
        worksheet.getRow(1).font = { size: 16, bold: true }
        worksheet.insertRow(2, [`기준일: ${AppLib.getToday()}`])
        worksheet.insertRow(3)
        // const row = worksheet.getRow(3)
        worksheet.getCell('G3').value = '수량'
        worksheet.getCell('G3').alignment = { vertical: 'middle', horizontal: 'center' }
        worksheet.mergeCells('G3:K3')

        worksheet.getCell('L3').alignment = { vertical: 'middle', horizontal: 'center' }
        worksheet.getCell('L3').value = '금액'
        worksheet.mergeCells('L3:O3')

        worksheet.getCell('P3').alignment = { vertical: 'middle', horizontal: 'center' }
        worksheet.getCell('P3').value = '부가액'
        worksheet.mergeCells('P3:Q3')

        const borderRight = {
          right: { style: 'thin' }, top: { style: 'thin' }, bottom: { style: 'thin' }
        }
        let totalRow = []
        for (let i = 1; i < 20; i++) {
          worksheet.getRow(3).getCell(i).alignment = { vertical: 'middle', horizontal: 'center' }
          worksheet.getRow(4).getCell(i).alignment = { vertical: 'middle', horizontal: 'center' }
          if (i <= 6) {
            worksheet.mergeCells(3, i, 4, i)
            worksheet.getRow(3).getCell(i).value = head[i - 1].header
            worksheet.getRow(3).getCell(i).border = borderRight
            worksheet.getRow(4).getCell(i).border = borderRight
          }
          if (i >= 18) {
            worksheet.mergeCells(3, i, 4, i)
            worksheet.getRow(3).getCell(i).value = head[i - 1].header
            worksheet.getRow(3).getCell(i).border = borderRight
            worksheet.getRow(4).getCell(i).border = borderRight
            if (i === 18) {
              worksheet.getRow(3).getCell(i).border = { right: { style: 'thin' }, top: { style: 'thin' }, bottom: { style: 'thin' }, left: { style: 'thin' } }
              worksheet.getRow(4).getCell(i).border = { right: { style: 'thin' }, top: { style: 'thin' }, bottom: { style: 'thin' }, left: { style: 'thin' } }
            }
          } else {
            if (i === 7 || i === 17) {
              worksheet.getRow(3).getCell(i).border = { top: { style: 'thin' }, left: { style: 'thin' }, right: { style: 'thin' } }
              worksheet.getRow(4).getCell(i).border = { bottom: { style: 'thin' }, top: { style: 'thin' }, left: { style: 'thin' } }
            } else {
              worksheet.getRow(3).getCell(i).border = { top: { style: 'thin' }, left: { style: 'thin' } }
              worksheet.getRow(4).getCell(i).border = { bottom: { style: 'thin' }, top: { style: 'thin' }, left: { style: 'thin' }, right: { style: 'thin' } }
            }
          }
          worksheet.getRow(3).getCell(i).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'a6daff' }
          }
          worksheet.getRow(4).getCell(i).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'a6daff' }
          }
          // column data format
          const dobCol = worksheet.getColumn(i)

          if (i >= 6 && i <= 17) {
            dobCol.eachCell(function (cell, rowNumber) {
              if (rowNumber > 4) {
                if (i === 11 || i === 17) {
                  cell.numFmt = '0%'
                } else { cell.numFmt = '#,##0' }
                cell.border = { right: { style: 'thin' } }
              }
            })
          }
          dobCol.eachCell(function (cell, rowNumber) {
            if (rowNumber > 4) {
              cell.border = { right: { style: 'thin' } }
              if (i === 1 && cell.value.indexOf('TOTAL') >= 0) {
                totalRow.push(rowNumber)
              }
            }
          })
        }
        // data cell border
        for (let m = 0; m < totalRow.length; m++) {
          // console.log(totalRow[m])
          for (let k = 1; k < 20; k++) {
            worksheet.getRow(totalRow[m]).getCell(k).border = { top: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
          }
        }
        for (let j = 0; j < salesInoutInfoDetail.length; j++) {
          const index = salesInoutInfoDetail[j].차종.indexOf('TOTAL')
          if (index === 0) {
            worksheet.mergeCells(j + 5, 1, j + 5, 6)
            worksheet.getCell(`A${j + 5}`).alignment = { vertical: 'middle', horizontal: 'center' }
            for (let k = 1; k < 20; k++) {
              worksheet.getRow(j + 5).getCell(k).fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'bdf9ff' }
              }
            }
          } else if (index > 0) { // grand total
            worksheet.mergeCells(j + 5, 1, j + 5, 6)
            worksheet.getCell(`A${j + 5}`).alignment = { vertical: 'middle', horizontal: 'center' }
            for (let k = 1; k < 20; k++) {
              worksheet.getRow(j + 5).getCell(k).fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'a6daff' }
              }
            }
          }
        }
      }
    },
    async onDetailFileChange ($event) {
      this.isLoading = true
      this.carFileReadError = false
      const fileName = $event.target.files[0].name + ''
      if (fileName === '' || fileName === undefined || fileName === null) {
        return
      }
      // console.log('************ onDetailFileChange=', fileName)
      this.bomInfoList = null
      this.readProductionInfoResult = null
      let vm = this
      let file = document.getElementById('batch-detail-input')['files'][0]
      this.$Q('#batch-detail-input').val('')

      const del = this.$_sp.runUpdateProc('spDeleteTempCarProductMap', [{ null: '' }])
      const product = this.$_sp.runNoEncodeFindSqlProc('품목정보', null)
      await axios.all([del, product])
        .then(axios.spread((...reponse) => {
          this.finishiedProduct = this.$_sp.MakeModel(reponse[1])
          console.log(this.finishiedProduct)
        }))

      this.errorArray = []
      this.optionProductArray = []
      let reader = new FileReader()
      reader.onloadend = function (event) {
        let arrayBuffer = reader.result
        const workbook = new ExcelJS.Workbook()
        workbook.xlsx.load(arrayBuffer).then(function (workbook) {
          let worksheet = workbook.getWorksheet('차종사양')
          vm.readCarOption(workbook, worksheet)
        })
      }
      reader.readAsArrayBuffer(file)
    },
    saveCarMap (worksheet, craBomArray, company) {
      this.isLoading = true

      let row = null
      let value = null
      let startColumn = 2
      let startRow = 8

      row = worksheet.getRow(3)
      value = AppLib.getCellFromExcel(row, 1)
      if (value === '차종') {
        startColumn = 1
        startRow = 5
      }
      let emptyRow = 0
      for (let i = startRow; i < 3000; i++) {
        row = worksheet.getRow(i)
        value = AppLib.getCellFromExcel(row, startColumn + 0)
        if (value !== null && (value.indexOf('T O T A L') >= 0 || value.indexOf('TOTAL') >= 0)) continue
        if (value === null || value === '소급정산') {
          if (emptyRow === 0) {
            emptyRow++
            continue
          } else {
            break
          }
        }
        emptyRow = 0
        let option = AppLib.getCellFromExcel(row, startColumn + 17)
        let splitOption = ['null']
        if (option !== null) {
          if (option !== 'A/S') {
            splitOption = AppLib.replaceAll(option, ',', '/')
            splitOption = splitOption.split('/')
          } else {
            continue
          }
        }
        for (let j = 0; j < splitOption.length; j++) {
          let dataJson = {}
          dataJson.발주사 = company
          dataJson.차종 = AppLib.getCellFromExcel(row, startColumn + 0) // 62709-J5000
          dataJson.납입품번 = AppLib.getCellFromExcel(row, startColumn + 1)
          dataJson.품번 = AppLib.getCellFromExcel(row, startColumn + 2)
          dataJson.품명 = AppLib.getCellFromExcel(row, startColumn + 3)
          dataJson.원단위 = AppLib.getCellFromExcel(row, startColumn + 4)
          dataJson.사양 = splitOption[j].trim()
          let parentSelfKey = `${dataJson.사양}${dataJson.차종}`
          const where = this.$_.findWhere(craBomArray, { 품번: dataJson.차종 })
          if (where === undefined || where.remark !== undefined) {
            // console.log('미등록 차종', dataJson.차종)
            dataJson.품명 = '미등록 차종'
            this.errorArray.push(dataJson)
          } else if (this.$_.findIndex(craBomArray, { selfKey: parentSelfKey }) < 0 || (dataJson.차종 === null || dataJson.품번 === null || dataJson.사양 === 'null')) {
            dataJson.품명 = '미등록 사양'
            this.errorArray.push(dataJson)
          } else {
            let index = this.$_.findIndex(this.finishiedProduct, { 품번: dataJson.품번 })
            if (index < 0) {
              dataJson.품명 = '미등록품번'
              this.errorArray.push(dataJson)
            } else {
              let item = {
                selfKey: AppLib.uuidSequential(),
                기준일: `${this.thisYear}-${this.thisMonth}-01`,
                품번: dataJson.품번,
                품명: dataJson.품명,
                수량: dataJson.원단위,
                발주사: this.$_.findWhere(this.customerLookup, { 거래처명: company }).거래처코드,
                상위품번: parentSelfKey,
                최상위품번: dataJson.차종,
                createid: this.userInfo.userName,
                updateid: this.userInfo.userName,
                납입품번: dataJson.납입품번
              }
              this.optionProductArray.push(item)
            }
          }
        }
      }
      this.isLoading = false
    },
    async readCarOption (workbook, worksheet) {
      let row = null
      let optionArray = []
      let carArray = []
      for (let i = 2; i < 500; i++) {
        row = worksheet.getRow(i)
        const option = AppLib.getCellFromExcel(row, 2)
        const value = AppLib.getCellFromExcel(row, 1)
        if (option === null) {
          // console.log(`read row=${i - 2}`)
          break
        }
        let remark = null
        if (this.$_.findIndex(carArray, { 품번: value }) < 0) {
          await this.$_sp.runNoEncodeFindSqlProc('고객사생산품목', { 모델코드: value, 사용유무: 1 })
            .then((data) => {
              if (this.$_sp.MakeModel(data).length === 0) {
                remark = '등록되지 않는 차종'
                this.carFileReadError = true
              }
            })
          const temp = {
            기준일: `${this.thisYear}-${this.thisMonth}-01`,
            selfKey: value,
            품번: value,
            품명: value,
            수량: 1.0,
            생산점유율: null,
            상위품번: null,
            최상위품번: value,
            createid: this.userInfo.userId,
            updateid: this.userInfo.userId,
            비고: remark
          }
          carArray.push(temp)
        }
      }
      let currentCarType = null
      for (let j = 2; j < 500; j++) {
        row = worksheet.getRow(j)
        const car = AppLib.getCellFromExcel(row, 1)
        if (car !== null) {
          currentCarType = car
        }
        const option = AppLib.getCellFromExcel(row, 2)
        if (option === null) {
          // console.log(`read row=${j - 2}`)
          break
        }
        let percent = AppLib.getCellFromExcel(row, 3)

        if (percent === `undefined`) {
          percent = 0
        }

        let optionJson = {
          기준일: `${this.thisYear}-${this.thisMonth}-01`,
          selfKey: `${option}${currentCarType}`,
          품번: option,
          품명: option,
          수량: 1.0,
          생산점유율: percent,
          상위품번: currentCarType,
          최상위품번: currentCarType,
          createid: this.userInfo.userId,
          updateid: this.userInfo.userId
        }

        optionArray.push(optionJson)
      }

      this.bomInfoList = carArray.concat(optionArray)
      // console.log(this.bomInfoList)
      const vm = this
      workbook.eachSheet(function (worksheet, sheetId) {
        if (worksheet.name !== '차종사양' && worksheet.name !== '생산계획' && worksheet.name !== '사양표' && worksheet.name !== '대수' && worksheet.name !== '제품가격' && worksheet.name.indexOf('Sheet') < 0) {
          vm.saveCarMap(worksheet, vm.bomInfoList, worksheet.name)
        }
      })
      this.isLoading = true
      setTimeout(() => {
        this.$_sp.runInsertSqlProc('TEMP_차종제품_맵', null, this.errorArray)
          .then((data) => {
            this.refreshReadProductionInfoResult()
            if (this.carFileReadError) {
              this.$snotify.info('등록되지 않은 차종이 있습니다.')
              this.initToggleEnableBtn(true)
            } else {
              this.$snotify.info('차종/사양 데이터가 이상이 없으면 차종 저장 버튼을 클릭하여 주세요')
              this.initToggleEnableBtn(false)
            }
          })
          .catch(error => {
            this.isLoading = false
            if (error.response.status === ConstDef.GENERRAL_ERROR) {
              // console.log(error.response.data.message)
            } else {
              // console.log(`에러코드 : ${error.response.status}`)
            }
          })
      }, 3000)
    },
    initToggleEnableBtn (isInit) {
      this.carProductionOpenBtn.option({ disabled: !isInit })
      this.carProductionSaveBtn.option({ disabled: isInit })
    },
    onToolbarPreparingSub (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;color:rgb(4, 103, 189);'><b>연도 :  </b></div>`
          }
        },
        {
          location: 'before',
          widget: 'dxSelectBox',
          options: {
            width: 70,
            items: this.yearArray,
            valueExpr: 'year',
            displayExpr: 'year',
            value: this.thisYear,
            onValueChanged: (args) => {
              this.thisYear = args.value
              this.refreshCarOptionList()
            }
          }
        },
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;color:rgb(4, 103, 189);'><b>월 :  </b></div>`
          }
        },
        {
          location: 'before',
          widget: 'dxSelectBox',
          options: {
            width: 60,
            items: this.monthArray,
            valueExpr: 'value',
            displayExpr: 'name',
            value: this.thisMonth,
            onValueChanged: (args) => {
              this.thisMonth = args.value
              this.refreshCarOptionList()
            }
          }
        },
        {
          location: 'after',
          widget: 'dxButton',
          options: {
            icon: 'file',
            text: '차종/품목 파일선택',
            disabled: false,
            type: 'default',
            focusStateEnabled: true,
            onInitialized: (args) => {
              this.carProductionOpenBtn = args.component
            },
            onClick: (args) => {
              this.$Q('#batch-detail-input').click()
            }
          }
        },
        {
          location: 'after',
          widget: 'dxButton',
          options: {
            icon: 'save',
            text: '차종/품목 저장',
            disabled: true,
            type: 'success',
            focusStateEnabled: true,
            onInitialized: (args) => {
              this.carProductionSaveBtn = args.component
            },
            onClick: (args) => {
              this.onSaveCarProduction()
            }
          }
        },
        {
          location: 'after',
          widget: 'dxButton',
          options: {
            icon: 'exportxlsx',
            disabled: false,
            hint: '엑셀파일 다운로드',
            focusStateEnabled: true,
            onClick: (args) => {
              this.exportExcel()
            }
          }
        }
      )
    },
    async onSaveCarProduction () {
      this.isLoading = true
      await this.$_sp.runDeleteSqlProc('BOM차종', [{ 기준일: `${this.thisYear}-${this.thisMonth}-01` }])
        .then((data) => {
          this.$_sp.runInsertSqlProc('BOM차종', ['비고'], this.bomInfoList)
            .then((data) => {
              this.initToggleEnableBtn(true)
              this.refreshCarOptionList()
            })
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
      const del = this.$_sp.runUpdateProc('spDeleteProductionFromBomCar', [{ 기준일: `${this.thisYear}-${this.thisMonth}-01` }])
      await axios.all([del])
        .then(axios.spread((...reponse) => {
        }))
      await this.$_sp.runInsertOrUpdayeSqlProc('BOM차종', ['selfKey'], ['납입품번'], this.optionProductArray)
        .then((data) => {
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })

      let 납입품번Array = []
      this.optionProductArray.forEach(item => {
        납입품번Array.push({ 품번: item.품번, 납입품번: item.납입품번 })
      })
      this.$_sp.runUpdateSqlProc('품목정보', ['품번'], null, 납입품번Array)
        .then((data) => {
          this.isLoading = false
          this.$snotify.info('저장 되었습니다.')
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    refreshCarOptionList () {
      this.$_sp.runNoEncodeFindProc('spFindAllBomCarByDate', { 기준일: `${this.thisYear}-${this.thisMonth}-01` })
        .then((data) => {
          this.bomInfoList = this.$_sp.MakeModel(data)
          // console.log(this.bomInfoList)
        })
    },
    // ********************** 엑셀파일 read result *************************
    onToolbarPreparingProduct (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;color:rgb(4, 103, 189);'><b>사양별 품목정보 맵핑 Error</b></div>`
          }
        }
      )
    },
    refreshReadProductionInfoResult () {
      this.isLoading = true
      this.$_sp.runNoEncodeFindProc('spFindAllTempCarOption', null)
        .then((data) => {
          this.isLoading = false
          this.readProductionInfoResult = this.$_sp.MakeModel(data)
          console.log(this.readProductionInfoResult)
        })
    }
  }
}
</script>

<style lang="scss">
.sub-content{
  .upload-result-wrap{
    width: 56%;
    margin-left:3%;
  }
  .car-option-wrap{
    width: 40%;
  }
}
</style>
